import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const PaperPlaneTiltIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M28.925 5.54242C28.925 5.54242 28.925 5.55492 28.925 5.56117L21.65 29.5537C21.5399 29.9434 21.3132 30.29 21.0004 30.5472C20.6876 30.8044 20.3036 30.9597 19.9 30.9924C19.8425 30.9974 19.785 30.9999 19.7275 30.9999C19.3492 31.0011 18.9785 30.894 18.6592 30.6914C18.3398 30.4887 18.085 30.1989 17.925 29.8562L13.4612 20.4324C13.4172 20.3392 13.403 20.2346 13.4207 20.133C13.4384 20.0314 13.487 19.9378 13.56 19.8649L20.7175 12.7062C20.8971 12.5171 20.9958 12.2654 20.9924 12.0046C20.9891 11.7438 20.884 11.4947 20.6996 11.3103C20.5152 11.1259 20.2661 11.0208 20.0053 11.0175C19.7446 11.0141 19.4928 11.1128 19.3037 11.2924L12.135 18.4499C12.0621 18.5229 11.9685 18.5715 11.8669 18.5892C11.7653 18.6069 11.6607 18.5927 11.5675 18.5487L2.19249 14.1074C1.8243 13.9387 1.51444 13.6646 1.30216 13.3197C1.08987 12.9748 0.984714 12.5746 0.999992 12.1699C1.02035 11.754 1.17094 11.3549 1.43047 11.0292C1.69 10.7035 2.04533 10.4676 2.44624 10.3549L26.4387 3.07992H26.4575C26.7991 2.98394 27.1601 2.98058 27.5034 3.07017C27.8468 3.15976 28.1601 3.33908 28.4112 3.58972C28.6624 3.84037 28.8423 4.15333 28.9326 4.49648C29.0229 4.83963 29.0203 5.20062 28.925 5.54242Z" />
  </svg>
);

PaperPlaneTiltIcon.propTypes = iconPropTypes;

export default PaperPlaneTiltIcon;
